<template>
  <div class="counsellors">
    <img
      @click="close()"
      class="closer"
      src="../assets/imgs/closer.svg"
      alt=""
    />

    <div class="infos">
      <h3>{{ infos.title }}</h3>
      <p>{{ infos.info }}</p>
    </div>

    <div
      class="select-container gap col-xs-12 col-md-12 col-lg-8 col-xl-6"
      style="margin: 16px 0"
    >
      <div class="canton">
        <label for="canton-select" style="margin-right: 8px">Kanton:</label>
        <select id="canton-select" v-model="selectedCanton">
          <option value="ALL">Alle</option>
          <option value="AUSLAND">Ausland</option>
          <option v-for="c in cantonOptions" :key="c.code" :value="c.code">
            {{ c.name }} ({{ c.code }})
          </option>
        </select>
      </div>

      <div class="children">
        <label for="children-select">Beratung Kinder:</label>
        <select id="children-select" v-model="selectedChild">
          <option value="ALL">Alle</option>
          <option value="YES">Ja</option>
          <option value="NO">Nein</option>
        </select>
      </div>
    </div>

    <div
      v-if="filteredList.length == 0"
      class="empty-state"
      :style="{ border: randomBorder() }"
    >
      <p>Keine Einträge gefunden...</p>
      <div class="empty-actions">
        <button @click="clearFilters">Filter zurücksetzen</button>
      </div>
    </div>

    <div v-else class="row gap row-mobile">
      <div
        class="counsel col-xs-12 col-md-6 col-lg-4 col-xl-3 col-3"
        v-for="(item, index) in filteredList"
        :key="index"
      >
        <div class="content" :style="{ border: randomBorder() }">
          <img :src="item.url || placeholderUrl" alt="" />
          <div class="content-text">
            <h3>{{ item.name }}</h3>
            <p v-if="item.phone">{{ item.phone }}</p>
            <p v-if="item.mail">{{ item.mail }}</p>
            <a
              v-if="item.website"
              :href="item.website"
              target="_blank"
              rel="noopener noreferrer"
              >{{ displayUrl(item.website) }}</a
            >
            <p v-if="item.location">{{ item.location }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { client } from '../main';
import avatarUrl from '../assets/imgs/avatar.svg';
import { getCantonCode, CANTON_LIST } from '@/utils/cantons';

export default {
  name: 'Counsellors-Section',
  props: {
    showCounsellors: Boolean,
  },
  data() {
    return {
      counsellors: [],
      selectedCanton: 'ALL',
      selectedChild: 'ALL',
      colors: ['#196492', '#EE8532', '#F0A9B1', '#E4422C', '#1C8741'],
      infos: '',
      placeholderUrl: avatarUrl,
    };
  },
  created() {
    this.getCounsellorData();
  },
  methods: {
    getCounsellorData() {
      client.getEntries({ content_type: 'beraterBeschreib' }).then((data) => {
        this.infos = data.items[0].fields;
      });

      client.getEntries({ content_type: 'berater' }).then((counsellordata) => {
        counsellordata.items.forEach((el) => {
          const fields = el.fields || {};
          const counsel = {};

          const allowed = [
            'name',
            'phone',
            'email',
            'website',
            'location',
            'children',
          ];
          allowed.forEach((key) => {
            const val = fields[key];
            if (val !== null && val !== undefined && val !== '') {
              if (key === 'email') counsel.mail = val;
              else counsel[key] = val;
            }
          });

          if (
            fields.portrait &&
            fields.portrait.fields &&
            fields.portrait.fields.file &&
            fields.portrait.fields.file.url
          ) {
            counsel.url = fields.portrait.fields.file.url;
          }

          const cantonCode = getCantonCode(fields.canton);
          counsel.location =
            (fields.location || '') + (cantonCode ? ' ' + cantonCode : '');
          counsel.canton = fields.canton || null;
          counsel.cantonCode = cantonCode;

          this.counsellors.push(counsel);
        });

        this.counsellors.sort((a, b) =>
          (a.name || '').localeCompare(b.name || '', undefined, {
            sensitivity: 'base',
          })
        );
      });
    },

    // combined filtering for canton and child-therapy
    filteredCounsellors() {
      let list = this.counsellors.slice();

      // canton
      if (this.selectedCanton && this.selectedCanton !== 'ALL') {
        if (this.selectedCanton === 'AUSLAND') {
          list = list.filter((c) => {
            const cantonStr = String(c.canton || '').toLowerCase();
            return (
              cantonStr.includes('ausland') || cantonStr.includes('abroad')
            );
          });
        } else {
          list = list.filter((c) => c.cantonCode === this.selectedCanton);
        }
      }

      // child therapy
      if (this.selectedChild && this.selectedChild !== 'ALL') {
        if (this.selectedChild === 'YES') {
          list = list.filter(
            (c) =>
              c.children === true || String(c.children).toLowerCase() === 'true'
          );
        } else if (this.selectedChild === 'NO') {
          list = list.filter(
            (c) =>
              !(
                c.children === true ||
                String(c.children).toLowerCase() === 'true'
              )
          );
        }
      }
      console.log(list, 'LIST');
      return list;
    },

    displayUrl(url) {
      return url.replace(/^https?:\/\//i, '').replace(/^www\./i, '');
    },

    randomBorder() {
      const number = Math.floor(Math.random() * this.colors.length);
      return `10px solid ${this.colors[number]}`;
    },

    clearFilters() {
      this.selectedCanton = 'ALL';
      this.selectedChild = 'ALL';
    },

    close() {
      this.$emit('close', 'close');
    },

    getCantonOptions() {
      const present = new Set(
        this.counsellors.map((c) => c.cantonCode).filter(Boolean)
      );
      const list = this.counsellors.length
        ? CANTON_LIST.filter((c) => present.has(c.code))
        : CANTON_LIST;
      return list.slice().sort((a, b) => a.name.localeCompare(b.name));
    },
  },

  computed: {
    cantonOptions() {
      return this.getCantonOptions();
    },
    filteredList() {
      return this.filteredCounsellors();
    },
  },
};
</script>

<style lang="scss" scoped>
.counsellors {
  width: 100vw;
  height: 100dvh;
  background-color: #f1f1f1;
  z-index: 300000;
  padding: 5vw;
  box-sizing: border-box;
  overflow: scroll;
  display: flex;
  flex-direction: column;
}

.closer {
  position: sticky;
  top: 0px;
  left: 100%;
  margin-left: auto;
  cursor: pointer;
  z-index: 300001;
}

.infos {
  margin-top: 24px;
  color: #196492;
  margin-bottom: 40px;
  h3 {
    font-size: clamp(1.2rem, -0.875rem + 4.66vw, 1.5rem);
    margin: 0;
  }
  p {
    font-size: 24px;
  }
}

.counsel {
  aspect-ratio: 1 / 1 !important;

  .content {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    border-radius: 16px;
  }
  h3 {
    margin: 0;
    margin-bottom: 8px;
    text-align: center;
  }
  img {
    width: 50%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 50%;
    margin-bottom: 16px;
  }
  p,
  a {
    text-align: center;
    display: block;
    width: 100%;
  }
}
.bld {
  font-family: 'Vulf Sans Medium';
}

.children,
.canton {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
}

.select-container {
  display: flex;
  flex-direction: row;
  label {
    margin-bottom: 4px;
    padding-left: 8px;
  }

  select {
    height: 48px;
    border-radius: 24px;
    border: none;
    box-sizing: border-box;
    padding: 0 16px 0 16px;
    font-family: 'Vulf Sans Medium';
    font-size: 18px;
    background: url("data:image/svg+xml,<svg height='16px' width='16px' viewBox='0 0 16 16' fill='%23000000' xmlns='http://www.w3.org/2000/svg'><path d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/></svg>")
      no-repeat;
    background-position: calc(100% - 0.75rem) center !important;
    -moz-appearance: none !important;
    -webkit-appearance: none !important;
    appearance: none !important;
    padding-right: 2rem !important;
    background-color: white;
    flex-grow: 1;
  }
}

.empty-state {
  text-align: center;
  margin-top: 64px;
  font-size: 18px;
  // background-color: lightgrey;
  padding: 40px 16px;
  border-radius: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;

  p {
    margin-bottom: 24px;
  }
}

button {
  height: 48px;
  border-radius: 24px;
  background-color: black;
  color: white;
  padding: 0 16px;
  font-family: 'Vulf Sans Medium';
  font-size: 18px;
  border: none;
  padding-bottom: 2px;
  box-sizing: border-box;
  cursor: pointer;

  &:hover {
    background-color: hsla(0, 0%, 20%, 1);
  }
}

@media (max-width: 961px) {
  .infos {
    margin-bottom: 32px;
    h3 {
      font-size: 24px;
      margin: 0;
    }
    p,
    a {
      font-size: 16px;
    }
  }

  .row-mobile {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }

  .counsellors {
    padding: 16px;
  }

  .gap > * {
    padding: 0px;
  }

  .counsel {
    aspect-ratio: 2 / 1 !important;

    .content {
      flex-direction: row;
      justify-content: flex-start;
      padding: 16px;
      gap: 16px;
    }
    img {
      width: unset;
      height: 80%;
      aspect-ratio: 1 / 1;
      margin-bottom: unset;
      padding: 16px;
    }
    h3 {
      margin: 0;
      text-align: left;

      font-size: 16px;
      font-size: clamp(1rem, -0.575rem + 4.66vw, 2rem);
    }
    p,
    a {
      text-align: left;
      font-size: 14px;
      font-size: clamp(0.8rem, -0.875rem + 4.66vw, 1.5rem);
    }
  }

  .select-container {
    gap: 16px;
  }
}

@media (max-width: 651px) {
  .counsel {
    img {
      padding: 0;
    }
    h3 {
      text-align: left;
    }
    p {
      word-break: break-word;
    }
  }

  .select-container {
    flex-direction: column;
    width: 100%;
    gap: 16px;
    padding-bottom: 16px;
  }
}

@media (min-width: 650px) {
}
</style>
